<template>
  <b-modal
    no-close-on-backdrop
    hide-footer
    :id="`view_code-${item.id}`"
    :title="`EDITAR CÓDIGO: ${item.code}`"
  >
    <form @submit.prevent="update">
      <WarningRequiredFields />
      <ErrorsMessages :errors="errors" />
      <div class="row">
        <div class="col-md-12 pt-0 pb-0">
          <v-autocomplete-default
            label="FORNECEDOR"
            :items="providers"
            :item-text="providerText"
            itemText="company_name"
            v-model="provider_id"
            required
          />
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <LabelRequiredField label="CÓDIGO" />
          <input v-model="code" type="text" class="form-control" />
        </div>
        <div class="col-md-6 pb-0">
          <v-btn
            @click="deleteCode"
            :disabled="loading"
            type="button"
            class="btn-delete"
          >
            <i class="fas fa-trash mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "APAGAR" }}
          </v-btn>
        </div>
        <div class="col-md-6 text-right pb-0">
          <v-btn :disabled="loading" type="submit" class="btn-save">
            <i class="fas fa-save mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "SALVAR" }}
          </v-btn>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";
import VAutocompleteDefault from "../Components/VAutocompleteDefault";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

export default {
  name: "Edit",

  components: {
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
    VAutocompleteDefault,
  },

  props: {
    providers: Array,
    item: Object,
  },

  data() {
    return {
      code: "",

      providerText: "",
      provider_id: "",

      errors: [],
      loading: false,
    };
  },

  created() {
    let { item } = this;

    this.id = item.id;
    this.provider_id = item.provider_id;
    this.code = item.code;
  },

  methods: {
    async update() {
      try {
        this.loading = true;

        let { id, provider_id, code, item } = this;

        let params = {
          id,
          code,
          provider_id,
          stock_item_id: item.stock_item_id,
        };

        const response = await api.put(
          "/rest-home/stock/stock-item-provider-code",
          params
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide(`view_code-${id}`);
          this.$emit("success");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteCode() {
      try {
        this.loading = true;

        let { id } = this;

        let data = { id };

        const response = await api.delete(
          "/rest-home/stock/stock-item-provider-code",
          { data }
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide(`view_code-${id}`);
          this.$emit("success");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
